import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import SaveIcon from "@material-ui/icons/Save";
import socketIOClient from "socket.io-client";
import axios from "axios";
import "../common/progressbtn.css"; // Import the CSS for custom styles
/*const socket = socketIOClient('http://edit.mybiocalculus.com:5000');*/
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    float: "left",
    height: "42px",
    marginLeft: "9%",
  },
  wrapper: {
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "155px",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
  progressButton: {
    width: "100px",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  started: {
    backgroundColor: "#FFD600 !important", // yellow
    color: "#000 !important",
  },
  // completed uses default color (no override)
}));

export default function CircularIntegration(props) {
  const socket = props.socket;
  var anl_btn_txt = "Analyze";
  var anl_btn_class = "btn-danger";
  const [loading, setLoading] = React.useState(false);
  const [idVal, setPatientID] = React.useState(" ");
  const [pro, setPro] = React.useState("0%");
  const [success, setSuccess] = React.useState(false);

  React.useEffect(() => {
    if (!socket) return;
    socket.on("connect", function () {
      console.log("connected");
    });

    socket.on("connect_error", function (err) {
      console.log(err);
    });

    socket.on("data", function (data) {
      var res = data.split("#");
      if (res[0] == props.id) {
        setPatientID(res[0]);
        setPro(res[1] + "-" + res[2] + "%");
        setLoading(true);
        if (parseInt(res[2]) >= 100) {
          setPro("Completed");
          anl_btn_txt = "Completed";
          setLoading(false);
        }
      }
    });

    socket.on("disconnect", function () {
      console.log("disconnected");
    });

    return () => {
      if (!socket) return;
      socket.off("connect");
      socket.off("connect_error");
      socket.off("data");
      socket.off("disconnect");
    };
  }, [socket, props.id]);

  const classes = useStyles();

  const timer = React.useRef();

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  React.useEffect(() => {}, [props.counter]);
  function analyze(e) {
    e.preventDefault();
    console.log("analyzeid", e.currentTarget.id);
    var userid = e.currentTarget.id;
    // Call onProgressStart callback if provided
    if (props.onProgressStart) {
      props.onProgressStart(userid);
    }
    props.onSelectModalComplete(userid);
  }
  function retrieve(e) {
    var userid = e.currentTarget.id;

    if (e.currentTarget.innerHTML == "Retrieve") {
      if (window.confirm("Do you want to retrieve the data from backup?")) {
        e.currentTarget.innerHTML = "Retrieving";
        axios
          .get(
            "https://web.mybiocalculus.com/html/Welcome/backupData/" + userid
          )
          .then((res) => {
            if (res.data != null) {
              console.log(res.data);
            } else {
              console.log("nothing");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
    }
  }
  function handleButtonClick(e) {
    if (!loading) {
      console.log(e.currentTarget.childNodes[0].innerText);
      var ele = e.currentTarget.childNodes[0];
      e.currentTarget.childNodes[0].innerText = "Retrieving";
      setSuccess(false);
      setLoading(true);

      timer.current = setTimeout(() => {
        setSuccess(true);
        setLoading(false);
        console.log("progress button");
        console.log(props.progress);
        ele.innerText = "Analyzed";
      }, 10000);
    }
  }
  // Custom logic for patient-list page
  if (props.isPatientListPage) {
    // For r_stat 6,3,4,5 show Analyze as btn-primary and text as 'Completed'
    if ([6, 3, 4, 5].includes(props.r_stat)) {
      anl_btn_txt = "Completed";
      anl_btn_class = "btn-primary";
    } else {
      anl_btn_txt = "Analyze";
      anl_btn_class = "btn-danger";
      if (props.r_stat == 2) {
        anl_btn_txt = "Started";
        anl_btn_class = classes.started;
      } else if (props.r_stat == 6) {
        anl_btn_txt = "Completed";
        anl_btn_class = "btn-success";
      }
    }
  } else {
    // Priority logic for r_stat (report status)
    if ([6, 3, 4, 5].includes(props.r_stat)) {
      anl_btn_txt = "Completed";
      anl_btn_class = "btn-primary";
    } else if (props.r_stat == 1) {
      anl_btn_txt = "Analyzing...";
      anl_btn_class = "btn-success";
    } else if (props.r_stat == 2) {
      anl_btn_txt = "Started";
      anl_btn_class = "btn-yellow";
    } else if (props.r_stat == 6) {
      anl_btn_txt = "Completed";
      anl_btn_class = "btn-success";
    } else {
      // Only check bc_stat if r_stat is not set or is 0
      if (
        props.bc_stat == 0 ||
        (props.bc_stat == undefined && props.r_stat != 0)
      ) {
        anl_btn_txt = "Analyze";
      } else if (props.r_stat == 0) {
        anl_btn_txt = "Analyze";
      } else if (props.bc_stat == 1) {
        anl_btn_txt = "Retrieve";
      } else if (props.bc_stat == 2) {
        anl_btn_txt = "Retrieving";
      }
    }
  }
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {props.id == idVal ? (
          <button
            type="button"
            id={props.id}
            className={
              "btn mr-20 " +
              (props.isPatientListPage && props.r_stat == 2
                ? classes.started +
                  " " +
                  props.r_stat +
                  " " +
                  classes.progressButton
                : anl_btn_class +
                  " " +
                  props.r_stat +
                  " " +
                  classes.progressButton)
            }
            ariant="contained"
          >
            {pro}
          </button>
        ) : (
          <button
            type="button"
            id={props.id}
            onClick={
              props.r_stat === 0
                ? analyze
                : props.r_stat === 2
                ? analyze
                : props.r_stat === 3
                ? (e) => props.onSelectModalComplete(props.id)
                : props.r_stat === 6
                ? (e) => props.onSelectModalComplete(props.id)
                : props.bc_stat === 1
                ? retrieve
                : null
            }
            className={
              "btn mr-20 " +
              (props.isPatientListPage && props.r_stat == 2
                ? classes.started +
                  " " +
                  props.r_stat +
                  " " +
                  classes.progressButton
                : anl_btn_class +
                  " " +
                  props.r_stat +
                  " " +
                  classes.progressButton)
            }
            ariant="contained"
            style={{ width: "100px" }}
          >
            {anl_btn_txt}
          </button>
        )}
      </div>
    </div>
  );
}
